import { ICommiunicationReportService } from './commiunicationreports.types'
import { http } from '@/shared/https'

export class CommiunicationReportsService implements ICommiunicationReportService {
    List(){
        return http.get("api/CallCommunicationTemplate/List")
        .then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            } else {
                throw (resp.data);
            }
        });
    }    

    GetById(id:number){
        return http.get(`api/CallCommunicationTemplate/${id}`)
            .then((resp: any) => {
                if (resp.status >= 200 && resp.status < 300) {
                    return resp.data;
                } else {
                    throw (resp.data);
                }
            });
    }
    Update(id:number,data:any){
        return http.put(`api/CallCommunicationTemplate/${id}`,data)
            .then((resp: any) => {
                if (resp.status >= 200 && resp.status < 300) {
                    return resp.data;
                } else {
                    throw (resp.data);
                }
            });
    }
    Delete(id:number){
        return http.delete(`api/CallCommunicationTemplate/${id}`)
            .then((resp: any) => {
                if (resp.status >= 200 && resp.status < 300) {
                    return resp.data;
                } else {
                    throw (resp.data);
                }
            });
    }
    Create(data:any){
        return http.post('api/CallCommunicationTemplate/',data)
            .then((resp: any) => {
                if (resp.status >= 200 && resp.status < 300) {
                    return resp.data;
                } else {
                    throw (resp.data);
                }
            });
    }
    GetInitiative(id: any)
    {
        return http.get(`api/CallCommunicationTemplate/InitiativeCall/${id}`)
            .then((resp: any) => {
                if (resp.status >= 200 && resp.status < 300) {
                    return resp.data;
                } else {
                    throw (resp.data);
                }
            });
    }
    GetSteps(id: any)
    {
        return http.get(`api/CallCommunicationTemplate/Template/${id}/Steps`)
            .then((resp: any) => {
                if (resp.status >= 200 && resp.status < 300) {
                    return resp.data;
                } else {
                    throw (resp.data);
                }
            });
    }
    GetDashboard()
    {
        return http.get(`api/GrantCommunication/PendingActions`).then((resp: any)=>{
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data
            } else {
                throw (resp.data);
            }
        })
    }
}